/**
 * HighRiskBehaviourWarning — top strip surfaced when there is at least
 * one HIGH-risk behaviour row missing a linked restrictive practice OR
 * an escalation instruction. P1 shows the warning prominently and
 * suggests next steps; P2 will hard-block approval (Q3 — answered).
 */
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert } from 'lucide-react';

export function HighRiskBehaviourWarning({ findings = [] }) {
  return (
    <Card className="border-rose-300 bg-rose-50" data-testid="structured-high-risk-warning">
      <CardContent className="p-3 flex items-start gap-3">
        <ShieldAlert className="h-5 w-5 text-rose-700 mt-0.5" />
        <div className="flex-1">
          <p className="font-semibold text-rose-800 text-sm">
            HIGH-risk behaviour rows need attention ({findings.length})
          </p>
          <p className="text-xs text-rose-700 mt-1">
            Each row tagged HIGH or CRITICAL risk in Behaviour Support must have either a
            linked Restrictive Practice authorisation or an explicit escalation instruction
            before this plan can be approved.
          </p>
          <ul className="text-xs text-rose-700 mt-2 space-y-1">
            {findings.slice(0, 5).map((f) => (
              <li key={f.row_id}>
                <code className="font-mono">{f.row_id}</code> · {f.risk_level} · {f.reason}
              </li>
            ))}
            {findings.length > 5 && <li>…and {findings.length - 5} more</li>}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}

export default HighRiskBehaviourWarning;
